module.exports = __webpack_public_path__ + "media/application/images/svgs/speaker-95059cfbc0047303002f36b854126a99.svg";